import { render, staticRenderFns } from "./ComedorVictoria.vue?vue&type=template&id=5cc98fcb&scoped=true"
import script from "./ComedorVictoria.vue?vue&type=script&lang=js"
export * from "./ComedorVictoria.vue?vue&type=script&lang=js"
import style0 from "./ComedorVictoria.vue?vue&type=style&index=0&id=5cc98fcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc98fcb",
  null
  
)

export default component.exports